// extracted by mini-css-extract-plugin
module.exports = {"tableOfContents":"ProjectSteps_tableOfContents__6fFpe","projectComplete":"ProjectSteps_projectComplete__4vtn8","futureImprovements":"ProjectSteps_futureImprovements__U_b_h"};